/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ResourceDropdownComponent} from './resource-dropdown/resource-dropdown.component';
import {FormsModule} from '@angular/forms';
import {ResourceIdDropdownComponent} from './resource-id-dropdown/resource-id-dropdown.component';
import {TranslateModule} from "@ngx-translate/core";
import { FloatLabel } from 'primeng/floatlabel';
import {
  BsAutocompleteComponent,
  BsItemDirective,
  BsEmptyDirective,
  BsFooterDirective,
  BsFloatLabelCompatDirective
} from 'iriro-frontend-libs/bs-component-store';
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    TranslateModule,
    FloatLabel,
    BsAutocompleteComponent,
    BsItemDirective,
    BsEmptyDirective,
    BsFooterDirective,
    BsFloatLabelCompatDirective
  ],
  declarations: [ResourceDropdownComponent, ResourceIdDropdownComponent],
  exports: [ResourceDropdownComponent, ResourceIdDropdownComponent],
})
export class ResourceDropdownModule {

}
